import styled from 'styled-components'
import { MenuIconButton } from '@sketch/components'

export const AddAnnotationButton = styled(MenuIconButton)`
  [role='img'] {
    width: 17px;
  }
`
